module.exports = __webpack_public_path__ + "img/1.e4d89d81.jpg";